// extracted by mini-css-extract-plugin
module.exports = {"animationG":"animationG_animationG__W3bDQ"};